import React from 'react';

const ChatClientContext = React.createContext(null);

export default ChatClientContext;
